export default __webpack_public_path__ + "static/media/invitation_high.a16b7f43.png";